import {
  CREATE_RADIO,
  DELETE_RADIO,
  EDIT_RADIO,
  RECEIVE_RADIOS,
  REQUEST_RADIO_LOOKUP,
} from '@sophocles/entities/Radio/radioActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_RADIOS:
      return state.merge(action.radios);
    case DELETE_RADIO:
      return state.delete(action.radio.toString());
    case REQUEST_RADIO_LOOKUP:
    case CREATE_RADIO:
    case EDIT_RADIO:
    default:
      return state;
  }
}

export function radioReducer(state = Map(), action) {
  switch (action.type) {
    case RECEIVE_RADIOS:
    case DELETE_RADIO:
    case REQUEST_RADIO_LOOKUP:
    case CREATE_RADIO:
    case EDIT_RADIO:
      return getState(state, action);
    default:
      return state;
  }
}
